const OSHA_300_CLASSIFICATION_OPTIONS = {
  death: 'Death',
  days_away_from_work: 'Days away from work',
  job_transfer: 'Remained at work - Job transfer or restriction',
  other_recordable_cases: 'Remained at work - Other recordable cases',
} as const;

export default OSHA_300_CLASSIFICATION_OPTIONS;
